@if (data$ | async; as data) {
  <app-uig-navigation-ui
    [node]="node$ | async"
    [ngClass]="data.styleClass"
    [wrapAfter]="data.wrapAfter"
  ></app-uig-navigation-ui>
}